import React, { useEffect, useState } from "react";
import LoadingButton from "@material-ui/lab/LoadingButton";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Typography,
  ListItem,
  Checkbox,
  ListItemIcon,
  ListItemText,
  List,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { tareasApi } from "src/services/tareasApi";
import { empleadosApi } from "src/services/empleadosApi";
import { AlertaModalV2 } from "../AlertaSwall";
import { useSnackbar } from "src/components/snackbar";

export default function SolicitarCambioEstadoDialog(props) {
  const { open, setOpen, tarea } = props;
  const { sucursal: sucursalObtenida } = useSelector(
    (state) => state.auth.user,
  );
  const sucursal = sucursalObtenida.refSucursal;

  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);

  const [empleadosAdministradores, setEmpleadosAdministradores] = useState([]);

  const [cargandoEditar, setCargandoEditar] = useState(false);

  const [solicitudCambioEstado] =
    tareasApi.useAddSolicitudCambioEstadoMutation();
  const { data: administradores, isError: errorAdministradores } =
    empleadosApi.useGetEmpleadosAdminSucursalQuery(sucursal);

  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (administradores) {
      setEmpleadosAdministradores(
        administradores.map((elemento) => ({
          ...elemento,
          seleccionado: false,
        })),
      );
    }
  }, [administradores]);

  useEffect(() => {
    if (errorAdministradores) {
      enqueueSnackbar(
        "Ocurrió un error en el servidor. Inténtelo nuevamente más tarde.",
        {
          variant: "error",
        },
      );
    }
  }, [errorAdministradores, enqueueSnackbar]);

  const editar = () => {
    AlertaModalV2({
      title: "¿Solicitar el cambio de estado?",
      text: "Se creara una solicitud para cambiar el estado, ¿Está seguro?",
      confirmButtonText: "Sí, solicitar",
      cancelButtonText: "Cancelar",
      icon: "question",
    })
      .fire()
      .then(async (result) => {
        if (result.isConfirmed) {
          setCargandoEditar(true);

          let dominio = new URL(window.location.href);
          try {
            await solicitudCambioEstado({
              refEmpleado: empleadoSeleccionado,
              idTarea: tarea.id,
              dominio: dominio.origin,
            }).unwrap();
            setCargandoEditar(false);
            setOpen(false);
            enqueueSnackbar("Solicitud enviada", {
              variant: "success",
            });
          } catch {
            enqueueSnackbar("Solicitud no enviada", {
              variant: "error",
            });
            setCargandoEditar(false);
          }
        }
      });
  };

  return (
    <Dialog open={open} fullWidth maxWidth="md" id="dialogSolicitudCambiada">
      <DialogTitle>Solicitar Cambio Estado</DialogTitle>
      <DialogContent>
        <Stack spacing={3} marginTop="10px">
          <Typography color="primary">Seleccionar Administrador</Typography>
          <List
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          >
            {empleadosAdministradores.map((value, idx) => {
              return (
                <ListItem key={idx} disablePadding>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={value.seleccionado}
                      tabIndex={-1}
                      disableRipple
                      onChange={(event) => {
                        let empleadosAdminAUX2 = empleadosAdministradores;
                        let arregloAUX = [];
                        empleadosAdminAUX2.forEach((e) => {
                          let elemento = e;
                          if (e.rut === value.rut) {
                            setEmpleadoSeleccionado(e.rut);
                            elemento.seleccionado = true;
                          } else {
                            elemento.seleccionado = false;
                          }
                          arregloAUX.push(elemento);
                        });
                        setEmpleadosAdministradores(arregloAUX);
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={value.nombre + " " + value.apellidos}
                  />
                </ListItem>
              );
            })}
          </List>
        </Stack>
      </DialogContent>
      <DialogActions>
        <LoadingButton onClick={handleClose} loading={cargandoEditar}>
          Cerrar
        </LoadingButton>
        <LoadingButton
          variant="contained"
          onClick={editar}
          autoFocus
          loading={cargandoEditar}
        >
          Solicitar Cambio Estado
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
